import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { ErrorModal } from "@dexteel/mesf-core";
import { Campaign } from "../models/Campaign";
import { CampaignSummaryCard } from "./CampaignSummaryCard";
import { MechanicalResultsCards } from "./mechanical-results/MechanicalResultsCards";
import {
	useHeatMechanicalResult,
	useHeatTestDisposition,
} from "@/pages/lab/chemistries/components/MechanicalResultsModal";

type Props = {
	campaign: Campaign | null;
	onClose: () => void;
};

export const CampaignDetails = ({ campaign, onClose }: Props) => {
	const [error, setError] = useState<string>("");

	const {
		data: dispositionsHistory,
		error: e,
		isError,
	} = useHeatTestDisposition({
		heatId: campaign?.HeatId!,
	});

	const {
		data: mechanicalData,
		error: mechanicalResultsError,
		isError: isMechanicalResultsError,
	} = useHeatMechanicalResult({
		heatId: campaign?.HeatId!,
	});

	const mechanicalResults = mechanicalData?.results;
	const hasHeatTestData = (mechanicalResults?.length ?? 0) > 0;

	useEffect(() => {
		if (
			(e && isError) ||
			(mechanicalResultsError && isMechanicalResultsError)
		) {
			setError(e?.message || mechanicalResultsError?.message || "Error");
		}
	}, [e, isError, mechanicalResultsError, isMechanicalResultsError]);

	return (
		<>
			{campaign === null ? (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						height: "100%",
						width: "100%",
					}}
				>
					<Typography>Select a campaign</Typography>
				</div>
			) : (
				<Stack spacing={2} p={2}>
					<CampaignSummaryCard campaign={campaign} />

					{!!campaign.HeatId && hasHeatTestData && (
						<Paper variant="outlined" sx={{ p: 1.5 }}>
							<MechanicalResultsCards
								results={mechanicalResults ?? []}
								requirement={mechanicalData?.requirement ?? null}
								dispositions={dispositionsHistory ?? []}
								curves={{
									heatId: campaign.HeatId,
									heatName: campaign.HeatName,
								}}
							/>
						</Paper>
					)}

					<Box display="flex" justifyContent="flex-end">
						<Button
							data-test-id="close-button"
							variant="contained"
							color="inherit"
							sx={{ minWidth: 160 }}
							onClick={onClose}
						>
							Close
						</Button>
					</Box>
				</Stack>
			)}
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
